<div>I/We the undersigned hereby authorise and give the Bank my/our irrevocable consent to:</div>
<br />
<div>
  (a) conduct credit checks on the Applicant, me/us (including but not limited to, checks with any credit bureau recognised as such by the
  Monetary Authority of Singapore) and obtain from and/or verify with any source and/or disclose or release any information relating to the
  Applicant, me/us and/or any guarantor or any of the Applicant’s, my/our and/ or any guarantor’s account(s) with the Bank to any other
  party or source (including but not limited to, any of the Bank’s Head Office, branches, representative offices, subsidiaries related
  corporations or affiliates worldwide, advisors, credit bureaus, credit reference agents, insurance/service providers, Central Provident
  Fund Board or governmental authorities/agencies) as the Bank may from time to time deem fit at the Bank’s absolute discretion and without
  any liability or notice to the Applicant, me/us or the guarantor.
</div>
<br />
<div>
  (b) disclose any information whatsoever concerning any matter or transaction in relating to the application and any other facility granted
  or to be granted by the Bank from time to time, any security relating hereto and any information whatsoever regarding the Applicant’s
  account(s) or affairs in accordance with the Bank’s right of disclosure as set out in the application form.
</div>
<br />
<div>
  I/We acknowledge and agree that nothing in this consent is to be construed as constituting an agreement between the me/us and the Bank 
  for a higher degree of confidentiality than that prescribed under applicable law (including, without limitation, Section 47 of, and in 
  the Third Schedule to, the Banking Act 1970 and Personal Data Protection Act 2012). On the contrary, if the Bank is bound by confidentiality 
  obligations imposed by the me/us under a non-disclosure or confidentiality agreement, my/our consent provided herein shall operate as 
  a waiver of any right or remedy which the I/us may be entitled to enforce under such non-disclosure or confidentiality agreement in respect 
  of the matters set out herein.
</div>
<div>
  I/We further acknowledge and agree that any consent given by me/us in relation to personal data of an 
  individual shall, subject to all applicable laws and regulations, survive death, incapacity, bankruptcy or insolvency of any such individual.
</div>
